// home.js
import React, { useEffect, useState, useRef } from 'react';
import $ from 'jquery';
import { Modal } from 'bootstrap';

import styles from '../../styles/components/searchInput.module.scss';

import { EmptyNote } from '../../components/note';
import { DataTable, FundsTab } from '../../components/dataFormating';
import { Loader } from '../../components/loader';
import { SecondaryBtn } from '../../components/cta';
import { DateRangePicker, SearchInput } from '../../components/input';
import { DeleteScheduledMessage, ViewMessageContent, ViewMessageUsers, PauseMessageModal, SendAgainMessage } from '../../components/modal';
import SelectBox from '../../components/dropdown/selectBox';
import moment from 'moment';
import APIPost from '../../services/postApi';
import APIGet from '../../services/getApi';
import devconfig from '../../config/config';

const HOME_TAB = [
    "Scheduled",
    "History"
];

const TYPE_FILTER = [
    { value: null, label: "All" },
    { value: 1, label: "Notification" },
    { value: 2, label: "Whats app" },
    { value: 3, label: "Email" }
]

const customDateSort = (a, b, selector, given) => {
    let format = given ? given : "DD MMM YYYY"
    if (a[selector] && b[selector]) return moment(a[selector], format).valueOf() - moment(b[selector], format).valueOf();
    else if (a[selector]) return -1;
    else if (b[selector]) return 1;
    else return 0;
};

const Home = (props) => {

    // 🔥 FIXED — replaced broken refs with state triggers
    const [paginationTrigger, setPaginationTrigger] = useState(0);
    const [dateTrigger, setDateTrigger] = useState(0);
    const [queryTrigger, setQueryTrigger] = useState(0);

    const [loader, setLoader] = useState(false);
    const [tabIndex, setTabIndex] = useState(1);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [pageNum, setPageNum] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [totalRecords, setTotalRecords] = useState(100);
    const [scheduleList, setScheduleList] = useState([]);
    const [selectedDelete, setSelectedDelete] = useState(null);
    const [selectedRow, setSelectedRow] = useState({});
    const [showViewContent, setShowViewContent] = useState(false);
    const [showViewUsers, setShowViewUsers] = useState(false);
    const [openPauseModal, setOpenPauseModal] = useState(null);
    const [isResume, setIsResume] = useState(false);
    const [openSendAgain, setOpenSendAgain] = useState(false);
    const [sendAgainData, setSendAgainData] = useState(null);
    const [search, setSearch] = useState(null);
    const [createdDate, setCreatedDate] = useState({
        start: null,
        end: null
    });
    const [selectedType, setSelectedType] = useState({ value: null, label: "All" })

    const SCHEDULE_LIST = [
        {
            name: 'Title',
            selector: row => row.title,
            sortable: false,
            left: true,
            minWidth: '400px',
            cell: row => <span dangerouslySetInnerHTML={{ __html: convertWhatsAppToHtml(row.title) }}/>
        },
        {
            name: 'Type',
            selector: row => row.channel_variable,
            sortable: false,
            left: true,
            width: '150px',
            cell: row => row.channel_variable
        },
        {
            name: 'Created on',
            selector: row => row.created,
            sortable: false,
            left: true,
            width: '150px',
            cell: row => row.created
        },
        {
            name: 'Scheduled for',
            selector: row => row?.scheduled_date,
            sortable: false,
            left: true,
            width: '150px',
            cell: row => row.scheduled_date
        },
        {
            name: 'Action',
            sortable: false,
            left: true,
            width: '450px',
            cell: row => (
                <div className='d-flex align-items-center'>
                    <span className='e-msg-history me-3' onClick={() => _viewContent(row)}>View content</span>

                    <span
                        className={row?.customers_list?.length ? 'e-msg-history me-3' : 'e-msg-history me-3 e-disabled-btn'}
                        onClick={() => _viewUsers(row)}
                    >
                        View users
                    </span>

                    <SecondaryBtn
                        name="Delete"
                        className='e-delete-btn-msg me-3'
                        handleClick={() => setSelectedDelete(row.id)}
                    />

                    <SecondaryBtn
                        name="Edit"
                        className='e-edit-btn-msg me-3'
                        handleClick={() => _openEdit(row)}
                    />

                    {row.status === "PAUSED" ? (
                        <SecondaryBtn
                            name="Resume"
                            className='e-edit-btn-msg'
                            handleClick={() => { setIsResume(true); setOpenPauseModal(row.id); }}
                        />
                    ) : (
                        <SecondaryBtn
                            name="Pause"
                            className='e-edit-btn-msg'
                            handleClick={() => { setIsResume(false); setOpenPauseModal(row.id) }}
                        />
                    )}
                </div>
            )
        },
    ];

    const HISTORY_COL = [
        {
            name: 'Title',
            selector: row => row.title,
            sortable: false,
            left: true,
            minWidth: '450px',
            cell: row => <span dangerouslySetInnerHTML={{ __html: convertWhatsAppToHtml(row.title) }}/>
        },
        {
            name: 'Type',
            selector: row => row.channel_variable,
            sortable: false,
            left: true,
            width: '150px',
            cell: row => row.type
        },
        {
            name: 'Sent on',
            selector: row => row.created,
            sortable: false,
            left: true,
            width: '150px',
            cell: row => <span>{row.created ? row.created : '-'}</span>
        },
        {
            name: 'Action',
            sortable: false,
            left: true,
            width: '450px',
            cell: row => (
                <div className='d-flex align-items-center'>
                    <span className='e-msg-history me-3' onClick={() => _viewContent(row)}>View content</span>

                    <span
                        className={row.customers_list?.length ? 'e-msg-history me-3' : 'e-msg-history me-3 e-disabled-btn'}
                        onClick={() => _viewUsers(row)}
                    >
                        View users
                    </span>

                    <SecondaryBtn
                        name="Send again"
                        className='e-edit-btn-msg'
                        handleClick={() => { setSendAgainData(row); setOpenSendAgain(true) }}
                    />
                </div>
            )
        },
    ];

    // INITIAL LOAD
    useEffect(() => {
        tabIndex === 1 ? _getScheduled() : _getHistory();
    }, [tabIndex]);

    // 🔥 FIXED — reactively triggers when user interacts (pagination, search, date)
    useEffect(() => {
        if (paginationTrigger > 0 || dateTrigger > 0 || queryTrigger > 0) {
            tabIndex === 1 ? _getScheduled() : _getHistory();
        }
    }, [paginationTrigger, dateTrigger, queryTrigger, tabIndex]);

    // MODALS
    useEffect(() => {
        if (selectedDelete !== null) {
            new Modal(document.getElementById("delete-schedule-message")).show();
        }
    }, [selectedDelete]);

    useEffect(() => {
        if (openSendAgain === true) {
            new Modal(document.getElementById("send-again-message-modal")).show();
        }
    }, [openSendAgain]);

    useEffect(() => {
        if (openPauseModal !== null) {
            new Modal(document.getElementById("pause-message-modal")).show();
        }
    }, [openPauseModal]);

    useEffect(() => {
        if (showViewContent === true) {
            new Modal(document.getElementById("view-message-content")).show();
        }
    }, [showViewContent]);

    useEffect(() => {
        if (showViewUsers === true) {
            new Modal(document.getElementById("view-message-users")).show();
        }
    }, [showViewUsers]);

    // OPEN VIEW CONTENT MODAL
    const _viewContent = (row) => {
        setSelectedRow(row);
        setShowViewContent(true);
    };

    // OPEN VIEW USERS MODAL
    const _viewUsers = (row) => {
        setSelectedRow(row);
        setShowViewUsers(true);
    };

    // PAGINATION SIZE CHANGE
    const _handlePerPage = (per_page) => {
        setPageSize(per_page);
        setPaginationTrigger(prev => prev + 1);
    };

    // PAGE NUMBER CHANGE
    const _handlePageChange = (page_num) => {
        setPageNum(page_num);
        setPaginationTrigger(prev => prev + 1);
    };

    // OPEN EDIT MODE
    const _openEdit = (data, status = false) => {
        props.openEditMode(data, status);
    };

    function convertWhatsAppToHtml(text) {
        if (!text) return "";

        let html = text;

        // bold + italics  *_text_*  or _*text*_
        html = html.replace(/\*_\s*(.*?)\s*_\*/g, "<strong><em>$1</em></strong>");
        html = html.replace(/_\*\s*(.*?)\s*\*_/g, "<strong><em>$1</em></strong>");

        // bold  *text*
        html = html.replace(/\*\s*(.*?)\s*\*/g, "<strong>$1</strong>");

        // italics  _text_
        html = html.replace(/_\s*(.*?)\s*_/g, "<em>$1</em>");

        // strikethrough  ~text~
        html = html.replace(/~\s*(.*?)\s*~/g, "<s>$1</s>");

        return html.replace(/\n/g, "<br>");
    }

    // API — SCHEDULED LIST
    const _getScheduled = () => {
        setLoader(true);
        const url = devconfig.admin + '/notification/list-schedule-messages';

        let payload = JSON.stringify({
            channel_type: null,
            page_num: pageNum,
            page_size: pageSize,
            start_date: createdDate.start,
            end_date: createdDate.end,
            query: search,
            channel_type: selectedType?.value
        });

        APIPost(url, payload).then((response) => {
            if (response.status_code === 200) {
                setScheduleList(response.data?.data);
                setTotalRecords(response.data.total_records);
            } else {
                setScheduleList([]);
                setTotalRecords(0);
            }
            setLoader(false);
        });
    };

    // API — HISTORY LIST
    const _getHistory = () => {
        setLoader(true);
        const url = devconfig.admin + '/notification/history';

        let payload = JSON.stringify({
            channel_type: null,
            page_num: pageNum,
            page_size: pageSize,
            start_date: createdDate.start,
            end_date: createdDate.end,
            query: search,
            channel_type: selectedType?.value
        });

        APIPost(url, payload).then((response) => {
            if (response.status_code === 200) {
                setScheduleList(response.data?.notification_data);
                setTotalRecords(response.data.total_records);
            } else {
                setScheduleList([]);
                setTotalRecords(0);
            }
            setLoader(false);
        });
    };

    const _scheduleDisabledDate = (current) => {
        if (current.isBefore(moment())) return true;
    };

    const _historyDisabledDate = (current) => {
        if (current.isAfter(moment())) return true;
    };

    return (
        <div className="row mt-2">

            {/* Tabs */}
            <div className="col-lg-12  mb-3">
                <FundsTab
                    data={HOME_TAB}
                    index={tabIndex}
                    setTab={(temp) => {
                        setPageNum(1);
                        setCreatedDate({ start: null, end: null });
                        setSelectedType({ value: null, label: "All" })
                        setTabIndex(temp);
                    }}
                />
            </div>

            <div className="e-filter-wraper e-sort mt-1">
                <div className="row align-items-end">

                    {/* Date Filter */}
                    <div className="col-lg-3 pe-1 col-4 ">
                        <label className="mb-1">
                            {tabIndex === 1 ? "Scheduled date" : "Sent on date"}
                        </label>

                        <DateRangePicker
                            onDatesChange={(start, end) => {
                                setPageNum(1);
                                setPageSize(10);
                                setCreatedDate({ start, end });
                                setDateTrigger(prev => prev + 1);
                            }}
                            disabledDate={tabIndex === 1 ? _scheduleDisabledDate : _historyDisabledDate}
                            start={createdDate.start}
                            end={createdDate.end}
                        />
                    </div>
                    <div className='col-2'>
                        <label>Channel type</label>
                        <SelectBox
                            value={Object.keys(selectedType).length > 0 ? selectedType : null}
                            options={TYPE_FILTER}
                            minHeight="39px"
                            selectchange={(temp) => {
                                setSelectedType(temp);
                                setPageNum(1);
                                setPageSize(10);
                                setPaginationTrigger(prev => prev + 1);
                            }}
                            isSearchable={false}
                        />
                    </div>

                    {/* Search */}
                    <div className='col-3 offset-4 text-end'>
                        <div className='d-flex align-items-center bg-white p-1'>
                            <div className='position-relative'>
                                <SearchInput
                                    placeholder="Search with name/email/number/ID"
                                    value={search}
                                    type="text"
                                    valueChange={(value) => {
                                        setSearch(value);
                                        if (value === "") {
                                            setPageNum(1);
                                            setPageSize(10);
                                            setQueryTrigger(prev => prev + 1);
                                        }
                                    }}
                                    onSearch={(value) => {
                                        setPageNum(1);
                                        setPageSize(10);
                                        setQueryTrigger(prev => prev + 1);
                                    }}
                                />

                                {search?.length > 0 && (
                                    <>
                                        {/* Search Click */}
                                        <span
                                            className={`${styles.e_search_submit}`}
                                            onClick={() => {
                                                setPageNum(1);
                                                setPageSize(10);
                                                setQueryTrigger(prev => prev + 1);
                                            }}
                                        ></span>

                                        {/* Clear Search */}
                                        <button
                                            className={`${styles.e_search_close} pe-3`}
                                            onClick={() => {
                                                setSearch("");
                                                setPageNum(1);
                                                setPageSize(10);
                                                setQueryTrigger(prev => prev + 1);
                                            }}
                                        ></button>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            {/* TABLE */}
            <div className="col-lg-12 px-0">
                {loader ? (
                    <Loader />
                ) : scheduleList?.length ? (
                    <DataTable
                        pagination={true}
                        columns={tabIndex === 1 ? SCHEDULE_LIST : HISTORY_COL}
                        data={scheduleList}
                        perPage={pageSize}
                        paginationServer={true}
                        selectableRows={false}
                        paginationTotalRows={totalRecords}
                        onChangeRowsPerPage={_handlePerPage}
                        onChangePage={_handlePageChange}
                        paginationDefaultPage={pageNum}
                        selectRows={() => { }}
                    />
                ) : (
                    <EmptyNote />
                )}
            </div>

            {/* DELETE MODAL */}
            {selectedDelete && (
                <DeleteScheduledMessage
                    message="Deleting this scheduled message will stop it from being sent at its scheduled time."
                    handleCloseModal={() => setSelectedDelete(null)}
                    id={selectedDelete}
                    success={_getScheduled}
                />
            )}

            {/* VIEW CONTENT MODAL */}
            {showViewContent && (
                <ViewMessageContent
                    data={selectedRow}
                    tabIndex={tabIndex}
                    deleteMessage={(id) => { setSelectedDelete(id); setShowViewContent(false); setSelectedRow({}) }}
                    closeModal={() => { setShowViewContent(false); setSelectedRow({}) }}
                    editMessage={(data) => { _openEdit(data); setShowViewContent(false); setSelectedRow({}) }}
                />
            )}

            {/* VIEW USERS MODAL */}
            {showViewUsers && (
                <ViewMessageUsers
                    data={selectedRow}
                    closeModal={() => { setShowViewUsers(false); setSelectedRow({}) }}
                />
            )}

            {/* PAUSE / RESUME MODAL */}
            {openPauseModal && (
                <PauseMessageModal
                    message={isResume
                        ? "Resuming this scheduled message will re-activate it and it will be sent at the scheduled time."
                        : "Pausing this scheduled message will temporarily stop it from being sent. You can resume it anytime before the scheduled time."
                    }
                    handleCloseModal={() => setOpenPauseModal(null)}
                    resume={isResume}
                    id={openPauseModal}
                    success={_getScheduled}
                />
            )}

            {/* SEND AGAIN MODAL */}
            {openSendAgain && (
                <SendAgainMessage
                    data={sendAgainData}
                    handleCloseModal={() => { setSendAgainData(null); setOpenSendAgain(false) }}
                    openEdit={(data) => { _openEdit(data, true); setSendAgainData(null); setOpenSendAgain(false) }}
                    success={_getScheduled}
                />
            )}

        </div>
    );
};

export default Home;
